<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
    <div id="wrapper">
      <!-- content:start -->
      <div id="content">
        <div class="contract"
          v-dragscroll
          ref="areaScrollable"
          @scroll="handleScroll"
          :style="{'height' : scrollableHeight + 'px', 'width' : scrollableWidth + 'px'}"
        >
          <div class="contract-head">
            <h1 class="hdg02">全サービスのライセンス</h1>
          </div>
          <div class="contract-table">
            <table>
              <thead>
                <tr>
                  <th rowspan="2" class="contract-table-hdg"><span>アカウント名</span></th>
                  <th v-for="(product,index) in state.products" :key="'product_' + index"><span class="txt-vertical">{{product.name}}</span></th>
                </tr>
                <tr>
                  <th v-for="(product,index) in state.products" :key="'product_state' + index">
                    <span v-if="product.status === PRODUCT_STATUS.TRIAL" class="txt-vertical">トライアル</span>
                    <span v-else class="txt-vertical">有効</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, userIndex) in state.users" :key="'user_' + userIndex">
                  <th>{{user.name}}</th>
                  <td v-for="(product,index) in state.products" :key="'user_' + userIndex + 'product' + index">
                    <template v-if="state.isActive(product, user)">●</template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractAssignLicenseTable } from '@/logic/contract/ContractAssignLicenseTable'

export default defineComponent({
  components: {
  },
  setup (props, context) {
    return { ...ContractAssignLicenseTable(context) }
  }
})
</script>

<style lang="scss" scoped>
#wrapper {
  padding: 0;
}
#wrapper:afer {
  display: none;
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow: auto;
  border-radius: 0;
}
.txt-vertical {
  writing-mode: vertical-lr;
  -ms-writing-mode: tb-lr;
  text-align: right;
  white-space: nowrap;
}
.contract {
  overflow: auto;
  display: block;
  &-head {
    padding: 25px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-table {
    table {
      border-collapse: collapse;
      td, th {
        border: 1px solid $color-line;
        padding: 12px 13px;
      }
      .sub {
        font-size: 1.2rem;
      }
      thead th{
        vertical-align: bottom;
        font-weight: normal;
        color: $color-thead;
        font-size: 1.4rem;
        padding: 15px 13px;
        &.contract-table-hdg {
          min-width: 200px;
          font-weight: bold;
          text-align: left;
          padding: 12px 20px;
        }
      }
      tbody {
        color: $color-content;
      }
      tbody td,
      thead td {
        text-align: center;
      }
      tbody th {
        font-size: 1.6rem;
        text-align: left;
        padding: 12px 20px;
      }
      tbody td {
        font-size: 20px;
      }
    }
  }
}
.contract {
  cursor : -webkit-grab;
  cursor : -moz-grab;
  cursor : -o-grab;
  cursor : grab;
}
.contract:active {
  cursor : -webkit-grabbing;
  cursor : -moz-grabbing;
  cursor : -o-grabbing;
  cursor : grabbing;
}
</style>
